import { z } from 'zod';

export interface DigitalAssistantStatusOption {
  label: string;
  value: 'published' | 'draft';
}

export const DIGITAL_ASSISTANT_STATUS_OPTIONS: DigitalAssistantStatusOption[] = [
  { value: 'published', label: 'Active' },
  { value: 'draft', label: 'Draft' },
];

/** The new-assistant form: a name and the key the API routes requests by. */
export const assistantCreateSchema = z.object({
  name: z.string().trim().min(1, 'Enter a name.'),
  assistantKey: z.string().trim().min(1, 'Enter an assistant key.'),
});

/** Inclusive day range. An unparseable date is never excluded. */
export function isWithinDateRange(iso: string, from: string, to: string): boolean {
  const timestamp = new Date(iso).getTime();
  if (Number.isNaN(timestamp)) {
    return true;
  }

  if (from) {
    const fromTimestamp = new Date(`${from}T00:00:00.000Z`).getTime();
    if (!Number.isNaN(fromTimestamp) && timestamp < fromTimestamp) {
      return false;
    }
  }

  if (to) {
    const toTimestamp = new Date(`${to}T23:59:59.999Z`).getTime();
    if (!Number.isNaN(toTimestamp) && timestamp > toTimestamp) {
      return false;
    }
  }

  return true;
}

export interface DigitalAssistantDateFilters {
  createdFrom?: string;
  createdTo?: string;
  updatedFrom?: string;
  updatedTo?: string;
}

/** A list row matches when both its created and updated dates fall inside their ranges. */
export function matchesDigitalAssistantDateFilters(
  dates: { createdAt: string; updatedAt: string },
  filters: DigitalAssistantDateFilters,
): boolean {
  return (
    isWithinDateRange(dates.createdAt, filters.createdFrom ?? '', filters.createdTo ?? '') &&
    isWithinDateRange(dates.updatedAt, filters.updatedFrom ?? '', filters.updatedTo ?? '')
  );
}
